import { useMemo } from 'react';
import { LangType } from '../../../../../../../../helpers/lang';
import { useLang } from '../../../../../../../../hooks/use-lang';
import { AdminType } from '../../../../../../../../store/api/admins-api';
import { useAdminsStore } from '../../../../../../../../store/use-admins-store';
import { useBranchesStore } from '../../../../../../../../store/use-branch-store';
import { IdValue } from '../../../../../../../../types/props';
import { adminRecord } from '../../helpers';

export const useCompanyAdminsCreateModalStep1 = () => {
  const { t, getLocale } = useLang();

  const { place } = useBranchesStore();
  const { handleUpdateAdmin, admin } = useAdminsStore();

  const i18nRoles: IdValue[] = Object.entries(adminRecord).map(([key, value]) => ({
    id: key,
    value: t(value),
  }));

  const branches = useMemo(
    () => place?.map((item) => ({ id: String(item.id), value: getLocale(item.name) })) || [],
    [place],
  );

  const handleChangeInput = (name: keyof AdminType, e: LangType) => {
    handleUpdateAdmin({ ...admin, [name]: e });
  };

  const selectedRole = i18nRoles.find((item) => item.id === admin?.role);

  return {
    t,
    admin,
    i18nRoles,
    branches,
    handleChangeInput,
    handleUpdateAdmin,
    selectedRole,
  };
};
